import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

export type HomeLanguage = "EN" | "GU";

interface HomeLanguageContextValue {
  language: HomeLanguage;
  setLanguage: (lang: HomeLanguage) => void;
  toggleLanguage: () => void;
}

const HomeLanguageContext = createContext<HomeLanguageContextValue | null>(null);

export function HomeLanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<HomeLanguage>("EN");
  const setLanguage = useCallback((lang: HomeLanguage) => setLanguageState(lang), []);
  const toggleLanguage = useCallback(
    () => setLanguageState((prev) => (prev === "EN" ? "GU" : "EN")),
    []
  );
  return (
    <HomeLanguageContext.Provider value={{ language, setLanguage, toggleLanguage }}>
      {children}
    </HomeLanguageContext.Provider>
  );
}

export function useHomeLanguage(): HomeLanguageContextValue {
  const ctx = useContext(HomeLanguageContext);
  if (!ctx) {
    throw new Error("useHomeLanguage must be used within HomeLanguageProvider");
  }
  return ctx;
}

/** Helper: return EN or GU string based on current home language */
export function getHomeText(lang: HomeLanguage, en: string, gu: string): string {
  return lang === "EN" ? en : gu;
}
